import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default function TermsConditionsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Asset Wave website and services, you accept and agree to be bound by 
                these Terms and Conditions. If you do not agree with any part of these terms, please do not use 
                our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Services Provided</h2>
              <p>
                Asset Wave provides financial advisory services including but not limited to:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Insurance planning and policy recommendations (Term, Health, Life Insurance)</li>
                <li>Investment advisory for mutual funds and SIP plans</li>
                <li>Retirement and tax planning consultation</li>
                <li>Financial goal planning and portfolio reviews</li>
              </ul>
              <p className="mt-4">
                <strong>Important:</strong> We are independent advisors and are not employees of any insurance 
                company or AMC. Our recommendations are based on your stated needs and risk profile.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. No Guaranteed Returns</h2>
              <p>
                All investments in mutual funds and market-linked insurance products are subject to market risks. 
                Past performance is not indicative of future results. We do not guarantee any specific returns or 
                outcomes. You are responsible for your investment decisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Advisory Services Disclaimer</h2>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Our advice is based on the information you provide. Accuracy of recommendations depends on the completeness and truthfulness of your disclosures.</li>
                <li>We recommend products based on our research and expertise, but final decisions rest with you.</li>
                <li>We are not responsible for changes in policy terms, benefits, or regulatory requirements by insurance companies/AMCs.</li>
                <li>Tax implications mentioned are based on current laws and may change. Consult a tax professional for specific advice.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Client Responsibilities</h2>
              <p>As a client, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Provide accurate and complete information about your financial situation, health, and goals</li>
                <li>Disclose all existing insurance policies and investments</li>
                <li>Inform us of any material changes in your circumstances</li>
                <li>Pay premiums on time to keep policies active</li>
                <li>Review policy documents received from insurance companies/AMCs</li>
                <li>Not hold us liable for policy rejections due to non-disclosure or misrepresentation</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Fees & Commissions</h2>
              <p>
                Our advisory services may be compensated through:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li><strong>Commissions:</strong> We may receive commissions from insurance companies/AMCs for policies/investments you purchase.</li>
                <li><strong>Fee-based:</strong> Some services may involve direct advisory fees (disclosed upfront).</li>
              </ul>
              <p className="mt-4">
                We operate transparently and will disclose our compensation structure upon request.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Regulatory Compliance</h2>
              <p>
                We comply with all applicable regulations including:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Insurance Regulatory and Development Authority of India (IRDAI)</li>
                <li>Securities and Exchange Board of India (SEBI)</li>
                <li>Association of Mutual Funds in India (AMFI)</li>
              </ul>
              <p className="mt-4">
                All licensed insurance and investment products are issued by respective companies, not by Asset Wave.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Privacy & Data Protection</h2>
              <p>
                Your personal and financial information is protected as outlined in our{' '}
                <Link to="/privacy-policy" className="text-blue-600 underline">Privacy Policy</Link>. 
                We do not share your information except as necessary to process applications and comply with regulations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Asset Wave is not liable for market losses, policy rejections, or claim denials by insurance companies/AMCs</li>
                <li>We are not responsible for delays or errors caused by third-party service providers</li>
                <li>Our liability is limited to the fees/commissions received for the specific service in question</li>
                <li>We are not liable for consequential, indirect, or punitive damages</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Intellectual Property</h2>
              <p>
                All content on this website (text, images, logos, calculators) is owned by Asset Wave and protected 
                by copyright laws. You may not reproduce, distribute, or modify any content without written permission.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Termination</h2>
              <p>
                Either party may terminate the advisory relationship at any time with written notice. Termination does 
                not affect existing insurance policies or investments, which remain subject to their respective terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Dispute Resolution</h2>
              <p>
                Any disputes arising from these terms will be resolved through:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>First, good-faith negotiation between parties</li>
                <li>If unresolved, mediation or arbitration as per Indian law</li>
                <li>Courts in [Your City] will have exclusive jurisdiction</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Grievance Redressal</h2>
              <p>
                For any complaints or concerns:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p><strong>Contact:</strong> K Satish</p>
                <p>Phone: <a href="tel:+919248852187" className="text-blue-600">+91 92488 52187</a></p>
                <p>Email: <a href="mailto:contact@assetwave.com" className="text-blue-600">contact@assetswaveww.com</a></p>
                <p className="mt-3 text-sm">
                  We aim to resolve all complaints within 7 working days. If unsatisfied, you may escalate to 
                  respective regulatory authorities (IRDAI, SEBI).
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms & Conditions at any time. Changes will be posted on this 
                page with an updated "Last updated" date. Continued use of our services constitutes acceptance of 
                modified terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Governing Law</h2>
              <p>
                These Terms & Conditions are governed by the laws of India. Any legal proceedings shall be subject 
                to the jurisdiction of courts in [Your City].
              </p>
            </section>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg mt-8">
              <p className="font-semibold">
                By using our services, you acknowledge that you have read, understood, and agree to these Terms & Conditions.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
